import {
  getLocalStorage,
  removeLocalStorage,
  setLocalStorage,
} from "./set-get-local-storage";

export const setAuthToken = (value) =>
  setLocalStorage(process.env.REACT_APP_TOKEN_NAME || `tATspy`, value, 24);
export const getAuthToken = () =>
  getLocalStorage(process.env.REACT_APP_TOKEN_NAME || `tATspy`) || undefined;
export const removeAuthToken = () =>
  removeLocalStorage(process.env.REACT_APP_TOKEN_NAME || `tATspy`);

export const setAuthTokenType = (value) =>
  setLocalStorage(
    process.env.REACT_APP_TOKEN_TYPE_NAME || `tATTspy`,
    value,
    24
  );
export const getAuthTokenType = () =>
  getLocalStorage(process.env.REACT_APP_TOKEN_TYPE_NAME || `tATTspy`) ||
  undefined;
export const removeAuthTokenType = () =>
  removeLocalStorage(
    process.env.REACT_APP_TOKEN_TYPE_NAME || `tATTspy`,
    "",
    24
  );

export const setUserDetails = (value) =>
  setLocalStorage(process.env.REACT_APP_USER_DETAILS || `tUDspy`, value, 24);
export const getUserDetails = () =>
  getLocalStorage(process.env.REACT_APP_USER_DETAILS || `tUDspy`) || undefined;
export const removeUserDetails = () =>
  removeLocalStorage(process.env.REACT_APP_USER_DETAILS || `tUDspy`);

export const setCurrentDeviceDetails = (value) =>
  setLocalStorage(
    process.env.REACT_APP_CURRENT_DEVICE_DETAILS || `tCDspy`,
    value,
    24
  );
export const getCurrentDeviceDetails = () =>
  getLocalStorage(process.env.REACT_APP_CURRENT_DEVICE_DETAILS || `tCDspy`) ||
  undefined;
export const removeCurrentDeviceDetails = () =>
  removeLocalStorage(process.env.REACT_APP_CURRENT_DEVICE_DETAILS || `tCDspy`);

export const setTempCurrentDeviceDetails = (value) =>
  setLocalStorage(
    process.env.REACT_APP_TEMP_CURRENT_DEVICE_DETAILS || `tTCDspy`,
    value,
    24
  );
export const getTempCurrentDeviceDetails = () =>
  getLocalStorage(
    process.env.REACT_APP_TEMP_CURRENT_DEVICE_DETAILS || `tTCDspy`
  );
export const removeTempCurrentDeviceDetails = () =>
  removeLocalStorage(
    process.env.REACT_APP_TEMP_CURRENT_DEVICE_DETAILS || `tTCDspy`
  );

export const setCurrentDeviceStatusSettings = (value) =>
  setLocalStorage(
    process.env.REACT_APP_CURRENT_DEVICE_STATUS_SETTINGS || `tTCDSSspy`,
    value,
    24
  );
export const getCurrentDeviceStatusSettings = () =>
  getLocalStorage(
    process.env.REACT_APP_CURRENT_DEVICE_STATUS_SETTINGS || `tTCDSSspy`
  );
export const removeCurrentDeviceStatusSettings = () =>
  removeLocalStorage(
    process.env.REACT_APP_CURRENT_DEVICE_STATUS_SETTINGS || `tTCDSSspy`
  );

export const setUIDetails = (value) =>
  setLocalStorage(process.env.REACT_APP_UI_DETAILS || `tUIDspy`, value, 24);
export const getUIDetails = () =>
  getLocalStorage(process.env.REACT_APP_UI_DETAILS || `tUIDspy`) || undefined;
export const removeUIDetails = () =>
  removeLocalStorage(process.env.REACT_APP_UI_DETAILS || `tUIDspy`);

export const setUserExtraDetails = (value) =>
  setLocalStorage(process.env.REACT_APP_UI_DETAILS_EXTRA || `tUDEspy`, value, 24);
export const getUserExtraDetails = () =>
  getLocalStorage(process.env.REACT_APP_UI_DETAILS_EXTRA || `tUDEspy`) || undefined;
export const removeUserExtraDetails = () =>
  removeLocalStorage(process.env.REACT_APP_UI_DETAILS_EXTRA || `tUDEspy`);

export const setAudioPlayRejacted = (value) =>
  setLocalStorage(process.env.REACT_APP_UI_DETAILS_EXTRA || `tUDAspy`, value, 24);
export const getAudioPlayRejacted = () =>
  getLocalStorage(process.env.REACT_APP_UI_DETAILS_EXTRA || `tUDAspy`) || undefined;
export const removeAudioPlayRejacted = () =>
  removeLocalStorage(process.env.REACT_APP_UI_DETAILS_EXTRA || `tUDAspy`);

export const setUserLanguage = (value) =>
  setLocalStorage(process.env.REACT_APP_USER_LANGUAGE || `tULspy`, value, 24);
export const getUserLanguage = () =>
  getLocalStorage(process.env.REACT_APP_USER_LANGUAGE || `tULspy`) || undefined;
export const removeUserLanguage = () =>
  removeLocalStorage(process.env.REACT_APP_USER_LANGUAGE || `tULspy`);

export const setUserlasselectedtLanguage = (value) =>
  setLocalStorage(process.env.REACT_APP_USER_LANGUAGE || `ltULspy`, value, 24);
export const getUserlasselectedLanguage = () =>
  getLocalStorage(process.env.REACT_APP_USER_LANGUAGE || `ltULspy`) ||
  undefined;
export const removeUserlasselectedLanguage = () =>
  removeLocalStorage(process.env.REACT_APP_USER_LANGUAGE || `ltULspy`);

export const setUserColorThemeMode = (value) =>
  setLocalStorage(
    process.env.REACT_APP_USER_COLOR_THEME_MODE || `tUCTMspy`,
    value,
    24
  );
export const getUserColorThemeMode = () =>
  getLocalStorage(process.env.REACT_APP_USER_COLOR_THEME_MODE || `tUCTMspy`) ||
  undefined;
export const removeUserColorThemeMode = () =>
  removeLocalStorage(process.env.REACT_APP_USER_COLOR_THEME_MODE || `tUCTMspy`);

export const setQuickAccessView = (value) =>
  setLocalStorage(
    process.env.REACT_APP_QUICK_ACCESS_VIEW_DETAILS || `tQVspy`,
    value,
    24
  );
export const getQuickAccessView = () =>
  getLocalStorage(
    process.env.REACT_APP_QUICK_ACCESS_VIEW_DETAILS || `tQVspy`
  ) || undefined;
export const removeQuickAccessView = () =>
  removeLocalStorage(
    process.env.REACT_APP_QUICK_ACCESS_VIEW_DETAILS || `tQVspy`
  );

export const cleanLocalStorage = () => {
  removeAuthToken();
  removeAuthTokenType();
  removeUserDetails();
  // removeCurrentDeviceDetails(); // To make sure user atfer logout user get their last selected device after login
  // removeTempCurrentDeviceDetails(); // To make sure user atfer logout user get their last selected device after login
  removeCurrentDeviceStatusSettings();
  removeQuickAccessView();
};

export const clearWholeLocalStorage = () => {
  removeAuthToken();
  removeAuthTokenType();
  removeUserDetails();
  removeQuickAccessView();
}